export class QBResponsePacket {
    constructor(statusCode: string, message: string = "") {
        this.message = message;
        this.statusCode = statusCode;
    }
    public statusCode: string;
    public message: string;
    public data: any;
}
